import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { initialize, reduxForm, Field, FieldArray, formValueSelector, change, reset } from 'redux-form';
import Helmet from 'react-helmet';
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import DropDownMenu from 'material-ui/DropDownMenu';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { LeftNavLayout } from 'containers';
import { ButtonBar, PageHeader, Spinner, DataTable } from 'components';
import { connect } from 'react-redux';
import { getAllContracts, getContracts } from 'redux/modules/contract';
import { updateSelectedSalesUser, updateView } from 'redux/modules/agreement';
import { getTeamMembers } from 'redux/modules/teamManagement';
import { browserHistory } from 'react-router';
import Divider from 'material-ui/Divider';
import lodash from 'lodash';
var Agreements = (_dec = reduxForm({
  form: 'agreementTableForm'
}), _dec2 = connect(function (state) {
  return {
    auth: state.auth,
    selectedView: state.agreement.selectedView,
    selectedSalesUserId: state.agreement.selectedSalesUserId,
    userType: state.config.userType,
    formValues: state.form.agreementTableForm && state.form.agreementTableForm.values ? state.form.agreementTableForm.values : {},
    organization: state.organization.current,
    allContracts: state.contract.allContracts,
    partnerAgreements: state.contract.partnerAgreements,
    clientAgreements: state.contract.clientAgreements,
    isLoadingContracts: state.contract.isLoadingContracts,
    theme: state.theme,
    teamMembers: state.teamManagement.teamMembers
  };
}, {
  getAllContracts: getAllContracts,
  getContracts: getContracts,
  change: change,
  getTeamMembers: getTeamMembers,
  updateView: updateView,
  updateSelectedSalesUser: updateSelectedSalesUser
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Agreements, _Component);

  var _super = _createSuper(Agreements);

  function Agreements(props) {
    var _this;

    _classCallCheck(this, Agreements);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "contractSearchOptions", function (searchQuery, sort) {
      return {
        sortBy: sort ? sort.key : null,
        order: sort ? sort.order : null,
        search: searchQuery
      };
    });

    _defineProperty(_assertThisInitialized(_this), "debounce", function (func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
            args = arguments;

        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleAgreementTableSearch", function (value) {
      _this.props.change('agreementTableForm', 'searchField', value);

      if (value.length === 0) {
        _this.props.getAllContracts();
      } else {
        _this.debounce(_this.props.getContracts(_this.contractSearchOptions(value), _this.props.formValues.columnSort));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleHeaderCellClick", function (header) {
      var setVal = null;

      if (!_this.props.formValues.columnSort || _this.props.formValues.columnSort.key !== header.key) {
        setVal = {
          key: header.key,
          order: 'desc'
        };
      } else if (_this.props.formValues.columnSort.key === header.key && _this.props.formValues.columnSort.order !== 'asc') {
        setVal = {
          key: header.key,
          order: 'asc'
        };
      }

      _this.props.change('agreementTableForm', 'columnSort', setVal);

      _this.debounce(_this.props.getContracts(_this.contractSearchOptions(_this.props.formValues.searchField, setVal)));
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonDropdownClick", function (event) {
      // This prevents ghost click.
      event.preventDefault();

      _this.setState({
        buttonDropdownOpen: true,
        anchorEl: event.currentTarget
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonBarChange", function (item) {
      _this.props.updateView(item.status);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowSelection", function (selectedRow) {
      _this.context.router.push("/global/agreements/".concat(selectedRow.uuid, "/teamview"));
    });

    _defineProperty(_assertThisInitialized(_this), "handleSalesUserChange", function (event, index, value) {
      _this.props.updateSelectedSalesUser(value);
    });

    _defineProperty(_assertThisInitialized(_this), "filterData", function (agreements) {
      if (_this.props.selectedSalesUserId === 'all') {
        return agreements;
      }

      return agreements.filter(function (a) {
        return "".concat(a.salesUserId) === "".concat(_this.props.selectedSalesUserId);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderButtonDropdown", function () {
      var buttonLabel = /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 13
        }
      }, "New", ' ', /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 9,
          paddingLeft: 6,
          top: -1,
          position: 'relative'
        }
      }, "\u25BC"));
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RaisedButton, {
        primary: true,
        onClick: _this.handleButtonDropdownClick,
        label: buttonLabel
      }), /*#__PURE__*/React.createElement(Popover, {
        open: _this.state.buttonDropdownOpen,
        anchorEl: _this.state.anchorEl,
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        onRequestClose: function onRequestClose() {
          _this.setState({
            buttonDropdownOpen: false
          });
        }
      }, /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: "Client Agreement",
        onClick: function onClick() {
          browserHistory.push('/global/agreements/new');
        }
      }), /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: "Partner Agreement",
        onClick: function onClick() {
          browserHistory.push('/global/agreements/partner/new');
        }
      }), /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: "Multilocation Agreement",
        onClick: function onClick() {
          browserHistory.push('/global/agreements/multilocation/new');
        }
      }), /*#__PURE__*/React.createElement(MenuItem, {
        primaryText: "Affiliate Agreement",
        onClick: function onClick() {
          browserHistory.push('/global/agreements/affiliate/new');
        }
      }))));
    });

    _this.state = {
      allContracts: [],
      buttonDropdownOpen: false,
      showModal: false,
      selectedContract: {}
    };
    return _this;
  }

  _createClass(Agreements, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.getAllContracts();
      this.props.getTeamMembers();

      if (this.props.selectedSalesUserId === '') {
        this.props.updateSelectedSalesUser(this.props.auth.user.id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var headerFields = [{
        name: 'Id',
        key: 'id'
      }, {
        name: 'First name',
        key: 'firstName'
      }, {
        name: 'Last name',
        key: 'lastName'
      }, {
        name: 'Email',
        key: 'email'
      }, {
        name: 'Business name',
        key: 'businessName'
      }, {
        name: 'User Agreed',
        key: 'userAgreed',
        renderAs: function renderAs(obj) {
          return obj.userAgreed ? 'Yes' : 'No';
        }
      }];
      var buttonBarItems = [{
        title: 'PARTNER',
        selected: this.props.selectedView === 'PARTNER',
        status: 'PARTNER'
      }, {
        title: 'MULTILOCATION',
        selected: this.props.selectedView === 'MULTILOCATION',
        status: 'MULTILOCATION'
      }, {
        title: 'AFFILIATE',
        selected: this.props.selectedView === 'AFFILIATE',
        status: 'AFFILIATE'
      }, {
        title: 'SMB',
        selected: this.props.selectedView === 'SMB',
        status: 'SMB'
      }];

      var sortedPartnerAgreements = function () {
        var d = {
          normal: [],
          ml: [],
          affiliate: []
        };

        _toConsumableArray(_this2.props.partnerAgreements).forEach(function (a) {
          if (a.isPartner) {
            d[function () {
              if (a.PartnerContracts && a.PartnerContracts.length) {
                if (a.PartnerContracts.some(function (p) {
                  return p.partnerType === 'multilocation';
                })) {
                  return 'ml';
                } else if (a.PartnerContracts.some(function (p) {
                  return p.partnerType === 'affiliate';
                })) {
                  return 'affiliate';
                }
              }

              return 'normal';
            }()].push(a);
          }
        });

        return d;
      }();

      var teamMembersInPartnership = _toConsumableArray(this.props.teamMembers).map(function (t) {
        var uo = t.UserOrganizations.find(function (uo) {
          return "".concat(uo.OrganizationId) === "".concat(_this2.props.theme.org);
        });

        if (uo) {
          return _objectSpread(_objectSpread({}, t), {}, {
            targetUserOrganization: uo
          });
        }

        return null;
      }).filter(function (o) {
        return o;
      });

      var activeTeamMemberOptions = _toConsumableArray(teamMembersInPartnership).filter(function (t) {
        return t.targetUserOrganization.status === 'ACTIVE';
      }).map(function (tm) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: tm.id,
          primaryText: "".concat(tm.name).trim() ? tm.name : tm.email
        });
      });

      var inactiveTeamMemberOptions = _toConsumableArray(teamMembersInPartnership).filter(function (t) {
        return t.targetUserOrganization.status !== 'ACTIVE' && function () {
          switch (_this2.props.selectedView) {
            case 'PARTNER':
              return sortedPartnerAgreements.normal;

            case 'MULTILOCATION':
              return sortedPartnerAgreements.ml;

            case 'AFFILIATE':
              return sortedPartnerAgreements.affiliate;

            default:
              return _this2.props.clientAgreements;
          }
        }().some(function (contract) {
          return "".concat(contract.salesUserId) === "".concat(t.id);
        });
      }).map(function (tm) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: tm.id,
          primaryText: "".concat(tm.name).trim() ? tm.name : tm.email
        });
      });

      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          padding: 36,
          overflow: 'auto'
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Agreements"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Agreements"
      }), this.renderButtonDropdown()), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ButtonBar, {
        items: buttonBarItems,
        onChange: this.handleButtonBarChange
      })), this.props.teamMembers && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: this.props.theme.colors.gray1,
          position: 'relative',
          top: 7,
          marginLeft: 16
        }
      }, "Filter By Team Member:"), /*#__PURE__*/React.createElement(DropDownMenu, {
        value: this.props.selectedSalesUserId,
        onChange: this.handleSalesUserChange,
        style: {
          top: -13
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: "all",
        primaryText: "All"
      }), /*#__PURE__*/React.createElement(Divider, null), !!activeTeamMemberOptions.length && /*#__PURE__*/React.createElement(MenuItem, {
        style: {
          cursor: 'default'
        },
        disabled: true
      }, "Active Team Members"), !!activeTeamMemberOptions.length && activeTeamMemberOptions, !!activeTeamMemberOptions.length && !!inactiveTeamMemberOptions.length && /*#__PURE__*/React.createElement(Divider, null), !!inactiveTeamMemberOptions.length && /*#__PURE__*/React.createElement(MenuItem, {
        style: {
          cursor: 'default'
        },
        disabled: true
      }, "Inactive Team Members"), !!inactiveTeamMemberOptions.length && inactiveTeamMemberOptions))), function () {
        var noDataMessage = function noDataMessage() {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-xs-12 "
          }, /*#__PURE__*/React.createElement("p", {
            style: {
              textAlign: 'center',
              fontWeight: 'bold'
            }
          }, "This Team Member has not created any", ' ', lodash.startCase("".concat(_this2.props.selectedView).toLowerCase()), ' ', "Agreements"));
        };

        switch (_this2.props.selectedView) {
          case 'PARTNER':
            if (_this2.props.allContracts.length > 0 && _this2.filterData(sortedPartnerAgreements.normal).length === 0) {
              return noDataMessage();
            }

            return /*#__PURE__*/React.createElement("div", {
              className: "col-xs-12 "
            }, /*#__PURE__*/React.createElement(DataTable, {
              columnSort: _this2.props.formValues.columnSort,
              headerFields: headerFields,
              data: _this2.filterData(sortedPartnerAgreements.normal),
              searchValueChanged: _this2.handleAgreementTableSearch,
              onHeaderCellClick: _this2.handleHeaderCellClick,
              fixedHeader: true,
              height: 500,
              isLoading: _this2.props.isLoadingContracts,
              displayLoading: true,
              onRowSelection: _this2.handleRowSelection
            }));

          case 'MULTILOCATION':
            if (_this2.props.allContracts.length > 0 && _this2.filterData(sortedPartnerAgreements.ml).length === 0) {
              return noDataMessage();
            }

            return /*#__PURE__*/React.createElement("div", {
              className: "col-xs-12 "
            }, /*#__PURE__*/React.createElement(DataTable, {
              columnSort: _this2.props.formValues.columnSort,
              headerFields: headerFields,
              data: _this2.filterData(sortedPartnerAgreements.ml),
              searchValueChanged: _this2.handleAgreementTableSearch,
              onHeaderCellClick: _this2.handleHeaderCellClick,
              fixedHeader: true,
              height: 500,
              isLoading: _this2.props.isLoadingContracts,
              displayLoading: true,
              onRowSelection: _this2.handleRowSelection
            }));

          case 'AFFILIATE':
            if (_this2.props.allContracts.length > 0 && _this2.filterData(sortedPartnerAgreements.affiliate).length === 0) {
              return noDataMessage();
            }

            return /*#__PURE__*/React.createElement("div", {
              className: "col-xs-12 "
            }, /*#__PURE__*/React.createElement(DataTable, {
              columnSort: _this2.props.formValues.columnSort,
              headerFields: headerFields,
              data: _this2.filterData(sortedPartnerAgreements.affiliate),
              searchValueChanged: _this2.handleAgreementTableSearch,
              onHeaderCellClick: _this2.handleHeaderCellClick,
              fixedHeader: true,
              height: 500,
              isLoading: _this2.props.isLoadingContracts,
              displayLoading: true,
              onRowSelection: _this2.handleRowSelection
            }));

          default:
            if (_this2.props.allContracts.length > 0 && _this2.filterData(_this2.props.clientAgreements).length === 0) {
              return noDataMessage();
            }

            return /*#__PURE__*/React.createElement("div", {
              className: "col-xs-12 "
            }, /*#__PURE__*/React.createElement(DataTable, {
              columnSort: _this2.props.formValues.columnSort,
              headerFields: headerFields,
              data: _this2.filterData(_this2.props.clientAgreements),
              searchValueChanged: _this2.handleAgreementTableSearch,
              onHeaderCellClick: _this2.handleHeaderCellClick,
              fixedHeader: true,
              height: 500,
              isLoading: _this2.props.isLoadingContracts,
              displayLoading: true,
              onRowSelection: _this2.handleRowSelection
            }));
        }
      }())));
    }
  }]);

  return Agreements;
}(Component), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object
}), _defineProperty(_class2, "defaultProps", {
  userType: {
    isLikeableUser: false
  }
}), _temp)) || _class) || _class);
export default Agreements;